






import Vue from 'vue';

const multiColorIcons = [
  {
    name: 'ico-crm',
    paths: 12
  },
  { name: 'ico-dropdown-delete-row', paths: 4 },

  { name: 'ico-dropdown-delete-column', paths: 4 },

  { name: 'ico-dropdown-insert-column-left', paths: 4 },

  { name: 'ico-dropdown-insert-column-right', paths: 4 },

  { name: 'ico-dropdown-insert-row-above', paths: 4 },

  { name: 'ico-dropdown-insert-row-below', paths: 4 },

  { name: 'ico-frame', paths: 13 },

  { name: 'ico-layers', paths: 22 },

  { name: 'ico-location', paths: 4 },

  { name: 'ico-marketplace', paths: 6 },

  { name: 'ico-planning-codes', paths: 5 },

  { name: 'ico-planning-portfolio', paths: 12 },

  { name: 'ico-check-circle', paths: 2 },

  { name: 'ico-file-upload', paths: 4 }
];

export default Vue.extend({
  props: {
    size: {
      type: String,
      required: false,
      default: '1.5'
    },
    color: {
      type: String,
      required: false
    }
  },
  computed: {
    iconClass(): string | undefined {
      if (this.$slots.default) {
        const slotText = this.$slots.default[0].text?.trim();

        // Adding support for material design icons
        if (slotText && slotText.includes('mdi-')) {
          return `mdi ${slotText}`;
        }
        return slotText;
      }

      return '';
    },
    iconPaths(): number {
      const multiColorIcon = multiColorIcons.find(icon => icon.name === this.iconClass);

      if (multiColorIcon) {
        return multiColorIcon.paths;
      }

      return 0;
    }
  }
});
